// extracted by mini-css-extract-plugin
export default {"wea":"wea_wea__Jvn6g","flex":"wea_flex__CSYFR"};